import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const ProfileStatModal = ({ title, value, history, onClose }) => {
    const { t } = useTranslation();

    const chartData = {
        labels: history.map(item => item.date),
        datasets: [
            {
                label: title,
                data: history.map(item => item.value),
                fill: false,
                backgroundColor: 'rgb(75, 192, 192)',
                borderColor: 'rgba(75, 192, 192, 0.2)',
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: `${title} ${t('profileStatModal.historyTitle')}`,
            },
        },
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="bg-gray-900/80 backdrop-blur-md p-6 rounded-lg shadow-glow max-w-md w-full text-white relative border border-blue-500/50" onClick={(e) => e.stopPropagation()}>
                <h3 className="text-xl font-bold mb-4 text-blue-300 font-playfair">{title}</h3>
                <p className="text-4xl font-bold text-center mb-4">{value}</p>
                {history.length > 0 ? (
                    <Line options={chartOptions} data={chartData} />
                ) : (
                    <div className="text-center text-gray-400">
                        <p>{t('profileStatModal.noHistory')}</p>
                    </div>
                )}
                <button onClick={onClose} className="absolute top-3 right-3 p-2 rounded-full bg-gray-700/50 hover:bg-gray-600/50 transition duration-300" aria-label={t('profileStatModal.closeAriaLabel')}>
                    <LucideIcons.X size={20} />
                </button>
            </div>
        </div>
    );
};

export default ProfileStatModal;